import { db } from '../firebase';
import {
    collection,
    getDocs,
    getDoc,
    doc,
    query,
    where,
    orderBy,
} from 'firebase/firestore';
import { COLLECTION_TESTIMONIALS } from '../shared/constants';

/**
 * Get all testimonials
 */
export async function getAllTestimonials() {
    try {
        const q = query(collection(db, COLLECTION_TESTIMONIALS), orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching testimonials:', error);
        throw error;
    }
}

/**
 * Get testimonials for a specific doctor
 */
export async function getTestimonialsForDoctor(doctorId) {
    try {
        const q = query(
            collection(db, COLLECTION_TESTIMONIALS),
            where('aboutDoctorId', '==', doctorId),
            where('status', '==', 'active'),
            orderBy('createdAt', 'desc')
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching testimonials for doctor:', error);
        throw error;
    }
}

/**
 * Get testimonials filtered by guild IDs (for coordinators)
 */
export async function getTestimonialsByGuilds(guildIds) {
    try {
        if (!guildIds || guildIds.length === 0) return [];

        const q = query(
            collection(db, COLLECTION_TESTIMONIALS),
            where('aboutDoctorGuildId', 'in', guildIds),
            orderBy('createdAt', 'desc')
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching testimonials by guilds:', error);
        throw error;
    }
}

/**
 * Get testimonial analytics
 */
export async function getTestimonialAnalytics() {
    try {
        const testimonials = await getAllTestimonials();

        const totalCount = testimonials.length;
        const averageRating = totalCount > 0
            ? testimonials.reduce((sum, t) => sum + (t.rating || 0), 0) / totalCount
            : 0;

        const ratingDistribution = {
            5: testimonials.filter(t => t.rating === 5).length,
            4: testimonials.filter(t => t.rating === 4).length,
            3: testimonials.filter(t => t.rating === 3).length,
            2: testimonials.filter(t => t.rating === 2).length,
            1: testimonials.filter(t => t.rating === 1).length,
        };

        return {
            totalCount,
            averageRating: averageRating.toFixed(2),
            ratingDistribution,
        };
    } catch (error) {
        console.error('Error calculating testimonial analytics:', error);
        throw error;
    }
}
